module.exports = __webpack_public_path__ + "img/1997.db8f76e3.jpg";